export default {
  "content": "<path d=\"M6.1 25.9c-.777-.778-.857-1.971-.176-2.652L23.248 5.924c.68-.68 1.874-.601 2.652.177.777.778.857 1.97.176 2.651L8.752 26.076c-.68.681-1.874.601-2.651-.176z\" fill=\"#3F4450\"/><path d=\"M23.248 26.076L5.924 8.752c-.68-.68-.601-1.873.176-2.651.778-.778 1.972-.858 2.652-.177l17.324 17.324c.68.68.601 1.874-.177 2.652-.777.777-1.97.857-2.651.177z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};